export default {
  bad_connection: '很抱歉，發生了不明錯誤。請確認您的網路連線，並稍後再試。',
  send: '發送',
  select_hotel: 'Please select the hotel you are staying',
  select_language: '請選擇您的語言。',
  start_chatting: 'Start Chatting',
  languages: '語言',
  menu: '選單',
  close: '關閉',
  back: '上一步',
  next: '下一步',
  message: '請以完整句子輸入您的問題',
  search: '開始搜尋',
  select: '選擇',
  sign_in: '登入',
  sign_out: '登出',
  sign_up: '註冊',
  smoking: '可吸菸',
  no_smoking: '禁菸',
  adults: '成人',
  xAdults: '成人',
  children: '兒童',
  ageOfChild: '兒童的年齢',
  seeAll: '顯示全部',
  email: '電子郵件地址',
  email_confirmation: '電子郵件地址 (確認用)',
  phone_number: '住客電話',
  icc: 'ICC',
  month: '月',
  year: '年',
  including_taxes: '含稅',
  excluding_taxes: '未含稅',
  show_more: '顯示更多',
  show_less: '顯示較少',
  file_upload: {
    unsupported_file_type: '非常抱歉，我們不支持{file_type}格式的文件。',
    file_size_exceeded: '文件超過大小的限制10mb',
    file_upload_failed: '文件上傳失敗',
    max_files_upload_simultaneously: '最多可同時上傳5份文件'
  },
  base: {
    back_to_list: '返回目錄',
    pay: '支付',
    cancel: '取消',
    delete: '刪除',
    yes: '是',
    no: '否',
    book: '預約',
    direct_price: '直銷價格',
    membership_rate: '會員價格',
    regular_rate: '標準價格',
    expand_for_price: '展開以比較',
    confirmSelection: '確認選擇',
    neverAskAgain: '不再顯示',
    accept: '同意',
    do_not_accept: '不同意',
    password: '密碼',
    email: '電子郵箱',
    save: '保存',
    confirm_password: '確認密碼',
    error02: '不好意思,處理過程時系統發生錯誤, 請稍後再試。',
    errorCode: {
      3001: '發生超時錯誤。支付尚未處理。',
      3002: '支付處理失敗。',
      3003: '此信用卡無法使用。',
      3004: '請確認信用卡號碼。',
      3005: '請確認有效日期是否正確。',
      3006: '3D驗證失敗。',
      3007: '信用卡輸入錯誤或無法使用。',
      3008: '3D驗證已被取消。',
      3009: '因多方要求，我們已經暫停3D驗證。',
      3011: '發生超時錯誤。支付尚未處理。',
      3203: '不好意思,處理過程時系統發生錯誤, 請稍後再試。',
      3204: '付款過程失敗，請使用其他卡，或稍後重試。',
      3205: '此信用卡無法使用。'
    }
  },
  triplaPayIssues: {
    INVALID_PARAMETER_SYNTAX: '請檢查您的輸入的資訊',
    INVALID_EXPIRATION_YEAR: '請確認有效日期是否正確。',
    Invalid_card_number: '請確認信用卡號碼。',
    Others: '請檢查您的輸入的資訊'
  },
  validation: {
    is_required: '{field}是必填的',
    correct_email: '請輸入正確的電子郵箱',
    invalid_integer: '請輸入一個整數。'
  },
  chat_body: {
    deleted_message: '您已經刪除此訊息',
    op_deleted_msg: '人工客服刪除此信息',
    delete_message: '刪除訊息',
    delete_message_desc: '您確定想要刪除此訊息嗎？請注意刪除後無法再復原'
  },
  user_top: {
    information:
      '如您想要繼續透過其他裝置與我們聊天，請註冊一個帳號。您可以在登入時擁有之前的聊天履歷。',
    terms_and_condition: {
      before: '已同意',
      link: '使用條款與政策',
      and: '和',
      privacy_policy: '隱私權政策',
      after: '。'
    },
    sign_in_with_facebook: '使用Facebook登入',
    sign_out_with_facebook: '在此裝置退出Facebook賬號',
    sign_in_with_line: '使用LINE登入',
    sign_in_with_weibo: '使用Weibo登入',
    create_account: '建立帳號',
    or: '或',
    already_have_an_account: '已經持有帳號？',
    sign_in_with_email: '使用電子郵件登入',
    forgot_password: '忘記密碼？'
  },
  new_user: {
    information: '請輸入姓名與電子郵件地址並點擊註冊。',
    information2: '您會收到來自chatbot@tripla.jp的認證信',
    first_name: '名字',
    last_name: '姓氏',
    name_placeholder: '您的姓名',
    email_placeholder: '電子郵件地址',
    submit: '註冊',
    email_sent:
      'A verification link has been sent to your email account. Please click on the link that has just been sent and {sign in}',
    error_message: {
      problem:
        'There was a problem creating your account. Please check your email address and try again.',
      email: '電子郵件地址無效或已被使用'
    }
  },
  new_session: {
    information: '請輸入姓名與電子郵件地址並點擊註冊',
    email_placeholder: '電子郵件地址',
    password_placeholder: '密碼',
    submit: '登入/登錄會員',
    error_message: {
      email: '非常抱歉，您輸入的電子郵件地址或密碼不正確',
      known_user_different: 'The known user is different'
    }
  },
  destroy_session: {
    information: '您希望登出嗎？ 如您想要顯示既有的聊天紀錄，您需要再次登入。',
    submit: '登出'
  },
  forgotten_password: {
    information: '請輸入電子郵件地址。 我們將會發送確認信到您的郵件帳戶。',
    email_placeholder: '電子郵件地址',
    submit: '寄出',
    error: 'Unable to reset password'
  },
  forgotten_password_confirmation: {
    information: '您將會在幾分鐘之內收到一封關於如何重設密碼的郵件。'
  },
  reset_password: {
    title: '更改密碼',
    password_title: '密碼',
    password_hint: '至少8個文字',
    password_confirmation_title: '密碼（確認）',
    submit: '更改密碼'
  },
  set_reset_password: {
    title: '更改密碼',
    information: '您的密碼已重設。',
    information2: '請回到登入頁面並再次登入。'
  },
  menu_items: {
    1: '查詢空房',
    2: '預訂客房',
    3: '確認預約'
  },
  modal: {
    back_to_chat: '返回聊天視窗'
  },
  gmoPaypalOptions: {
    visa: 'VISA',
    master: 'Mastercard',
    mastercard: 'Mastercard',
    amex: 'American Express',
    jcb: 'JCB',
    diners: 'Diners Club'
  },
  credit_card: {
    error: {
      cvv: '請確認您的CVV(安全碼)是否正確。',
      expiration: '請確認有效日期是否正確。',
      name: '請確認信用卡持卡人的姓名是否正確。',
      number: '請使用有效的信用卡。',
      unknown: '您的申請出現了問題, 請再次確認您輸入的內容是否正確。',
      reservation_month:
        '請確認您輸入的信用卡有效期限必須是在您預約月份之後(例：如要預約8月的話, 信用卡的有效期間必須要在8月之後)'
    },
    accept: '我們接受：',
    cvv: 'CVV(安全碼)',
    expiration: '有效日期',
    intro: '請輸入您的信用卡資訊',
    name: '持卡人姓名',
    number: '信用卡號碼',
    save: '保存這張信用卡',
    submit: '新增信用卡',
    title: '新增新的信用卡',
    security_code: '安全碼(CVV)',
    card_holder_confirm: '請再次確認信用卡姓名',
    card_holder_format_confirm: '請用羅馬拼音輸入姓名。',
    expiration_confirm: '請再次確認信用卡有效期限',
    card_cvv_confirm: '請再次確認信用卡安全碼',
    card_number_confirm: '請再次確認信用卡號碼',
    card_brand: '信用卡組織',
    select_card_brand: '請選擇信用卡組織'
  },
  payment: {
    total: '總額'
  },
  currencies: {
    JPY: '日元'
  },
  chat_channels: {
    title: '請選擇頻道',
    facebook: 'Messenger',
    web: 'Web',
    line: 'LINE',
    whats_app: 'WhatsApp'
  },
  rev_requests: {
    title: '申請一覧',
    request: '申請',
    status: '狀態',
    no_data: '目前沒有請求',
    payment: '支付',
    customer: '顧客',
    phone: '電話號碼',
    people: '人數',
    facility_name: '設施名稱',
    requested_day: '希望日期',
    requested_time: '希望時間',
    confirm_cancel_msg:
      '請確認希望取消此項申請。我們將向管理員發送通知。取消完成後，您將收到有關的結果通知。',
    cancel_request: '取消申請',
    edit_request: '修改申請',
    keep_request: '保留申請'
  },
  requests: {
    statuses: {
      _destroyed: '消除',
      cancel_requested: '要求取消',
      cancelled: '取消',
      change_requested: '變更中',
      created: '要處理',
      departure_unconfirmed: '出發尚未確認',
      done: '完成',
      in_progress: '確認中',
      no_show: '沒有出現',
      stopped: '中止出發',
      wait_listed: '候補',
      waiting_detail: '詳情等候中'
    }
  },
  best_rate: '最優惠價格',
  time_picker: {
    AM: '上午',
    PM: '下午'
  },
  details_page: {
    details: '查看詳細內容'
  },
  date_range: {
    select: '選擇您的入住日期',
    send: '點擊“選擇”以繼續',
    no_disabled_dates: '您所選擇的住宿日子已滿, 請選擇其他有空位的日子'
  },
  facebook: {
    email_sent: '我們已將確認鏈接發送至您的電郵地址，請點擊鏈接確認預約。',
    no_email: '請輸入您的電郵地址。預約完成後，我們將發送確認預約郵件至您的電郵地址。',
    signInFailed: '登錄失敗，請重新再試。',
    sign_out: '請點擊此按鈕以退出Facebook的帳號。'
  },
  confirm_form: {
    search: '重新搜索客房',
    update_contact: '修改聯繫資料'
  },
  contact_form: {
    update: '更新',
    submit: '送出',
    full_name: '姓名（羅馬拼音）',
    family_name: '姓',
    first_name: '名字',
    cc_email: '傳送郵件副本給...',
    error: {
      full_name_error: '請輸入姓名的羅馬拼音。',
      tel_format_error: '電話的輸入可接受數字，空格，（），＋等。',
      tel_length_error: '電話號碼需為9個數字以上。',
      email_format_error: '請提供正確的電子郵箱。（輸入例 name@gmail.com）',
      email_confirmation_error: 'email addresses not identical'
    }
  },
  room_not_available: '非常抱歉，根據您所選擇的房型，目前并沒有合適的方案，請重新搜尋。',
  search_again: '重新搜索客房',
  room_not_available_short: '無法使用',
  email_form: {
    note_placeholder: '請輸入洽詢的詳情。'
  },
  rental_car_form: {
    pickup_title: '取車店鋪',
    pickup_area: '選擇區域',
    pickup_shop: '選擇店鋪',
    pickup_date_time: '取車日期與時間',
    return_title: '還車店鋪',
    return_area: '選擇區域',
    return_shop: '選擇店鋪',
    return_date_time: '還車日期與時間',
    back: '返回'
  },
  search_area_form: {
    select_prefecture_area: '請選擇省份及區域',
    prefecture: '州份/行政區域/省份',
    area: '區域'
  },
  restaurant_form: {
    breakfast: '早餐',
    lunch: '午餐',
    dinner: '晚餐',
    main_time: '希望時間',
    alternative_times: '其他希望的時間',
    pick_multiple: '可複數',
    any_available_time: '任何時間皆可'
  },
  terms_of_use: '使用條款',
  privacy_policy: '隱私權條款',
  browser_warning:
    '您的網頁瀏覽器不是最新版本。請更新瀏覽器版本，以便獲得更安全，更快速和最佳的體驗。',
  for_night: '住宿{n}晚',
  chat_icon: {
    chat: '聊天窗口'
  },
  chat_evaluation: {
    title: '客戶滿意度',
    msg: '請問您對我們的聊天機器人滿意嗎?',
    not_satisfied: '不滿意',
    satisfied: '滿意'
  },
  cookie_consent: {
    title: '管理Cookie政策',
    necessary: '必須同意: 聊天記錄和登入狀態',
    functional: '功能: Cookie將保存隱私政策和聊天機器人的設定。',
    performance: '性能: Cookie將計算訪問次數和用戶點擊次數，從以幫助我們改善服務。',
    advertising: '目標和廣告: Cookie使廣告信息與您相關。',
    accept_all: '全部接受',
    confirm: '確認我的選擇',
    cookies_accepted: '接受Cookies'
  },
  ota_name: {
    agoda: 'Agoda',
    booking_com: 'Booking com',
    expedia: 'Expedia',
    jalan: 'Jalan',
    rakuten_travel: 'Rakuten Travel',
    rakutenTravel: 'Rakuten Travel'
  }
}
